import { render, staticRenderFns } from "./RoleHeader.vue?vue&type=template&id=19bde224"
import script from "./RoleHeader.vue?vue&type=script&lang=js"
export * from "./RoleHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports